/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import { ModalContext } from './ModalContext';

interface ModalProps 
{
    [key : string] : any;

    setOpen      : (open : boolean) => void;
    Component?   : React.FunctionComponent<any>;
    canClickOut? : boolean;
}

export const Modal: React.FunctionComponent<ModalProps> = ({ 
    setOpen,
    Component,
    canClickOut = true,
    children,
    ...rest
}) => 
{
    const modalRoot = document.getElementById('modal-root');
    
    if (!modalRoot) return null;
    return createPortal(
        <ModalContainer>

            <ModalContext.Provider value={{ close: () => setOpen(false) }}>
                <ModalContent>
                    <ModalShadow onClick={canClickOut ? () => setOpen(false) : () => {}} />
                    {children}
                    {Component && <Component {...rest} />}
                </ModalContent>
            </ModalContext.Provider>
        </ModalContainer>, 
        modalRoot
    );
};

const ModalContainer = styled.div`
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999999999999;
    box-sizing: border-box;
    overflow-y: auto;
`;

const ModalContent = styled.div`
    width: 100%;
    min-height: 100vh;
    padding: 4rem 2rem;
    box-sizing: border-box; 
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const ModalShadow = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0,0,0,0.1);
`;
